import { fetchFollowers } from 'utils/queries/follows'

import { Follow } from 'types/follow'

import { useQuery } from './useQuery'

/// Returns the users who follow `current user`
export const useFollowers = (userId: string | undefined) => {
  const followersQuery = useQuery<Array<Follow> | null>(['followers', userId], () =>
    fetchFollowers({ userId }),
  )

  const result =
    !Array.isArray(followersQuery.data) && followersQuery.data
      ? [followersQuery.data]
      : followersQuery.data

  return {
    ...followersQuery,
    data: result,
  }
}
